/** @format */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const Sidebar = () => {
	return (
		<>
			<div className='row sidebar-row'>
				<Link to='/categories' className='col-12'>
					<span style={iconStyling}>
						<FontAwesomeIcon icon={faListAlt} />
					</span>
					دسته بندی ها
				</Link>

				<Link to='/products' className='col-12'>
					<span style={iconStyling}>
						<FontAwesomeIcon icon={faListAlt} />
					</span>
					محصولات
				</Link>
				<Link to='/order' className='col-12'>
					<span style={iconStyling}>
						<FontAwesomeIcon icon={faListAlt} />
					</span>
					سفارشات
				</Link>
			</div>
		</>
	);
};

const iconStyling = {
	display: 'inline-block',
	paddingLeft: '10px',
};

export default Sidebar;
